[
  {
    "id": "SR-B8-LV-PANNENKOEK-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "zinsontleding",
    "subSkill": "lijdend_voorwerp",
    "familyId": "SR-LIJDEND-VOORWERP-VINDEN",
    "conceptId": "find_direct_object",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het lijdend voorwerp in de zin: 'De kok bakt een pannenkoek.'",
    "options": ["een pannenkoek", "De kok", "bakt", "een"],
    "correctAnswer": 0,
    "explanation": "Het lijdend voorwerp is datgene waarmee iets gedaan wordt. Vraag: Wat bakt de kok? Een pannenkoek. Dat is het lijdend voorwerp.",
    "distractorExplanations": {
      "1": "'De kok' is het onderwerp (wie bakt?).",
      "2": "'Bakt' is de persoonsvorm.",
      "3": "'Een' is een lidwoord — onderdeel van het lijdend voorwerp, niet het hele lijdend voorwerp."
    }
  },
  {
    "id": "SR-B8-MV-ZUS-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "zinsontleding",
    "subSkill": "meewerkend_voorwerp",
    "familyId": "SR-MEEWERKEND-VOORWERP-VINDEN",
    "conceptId": "find_indirect_object",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het meewerkend voorwerp in de zin: 'Ik geef mijn zus een cadeau.'",
    "options": ["mijn zus", "Ik", "een cadeau", "geef"],
    "correctAnswer": 0,
    "explanation": "Het meewerkend voorwerp is de persoon voor wie iets gedaan wordt. Vraag: Aan wie geef ik een cadeau? Aan mijn zus.",
    "distractorExplanations": {
      "1": "'Ik' is het onderwerp (wie geeft?).",
      "2": "'Een cadeau' is het lijdend voorwerp (wat geef ik?).",
      "3": "'Geef' is de persoonsvorm."
    }
  },
  {
    "id": "SR-B8-WOORDSOORT-SNEL-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "woordsoorten",
    "subSkill": "woordsoorten",
    "familyId": "SR-BIJWOORD-HERKENNEN",
    "conceptId": "identify_adverb",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woordsoort is 'snel' in de zin: 'De auto rijdt snel.'",
    "options": ["Bijwoord", "Bijvoeglijk naamwoord", "Werkwoord", "Zelfstandig naamwoord"],
    "correctAnswer": 0,
    "explanation": "'Snel' zegt hier iets over het werkwoord 'rijdt' (hoe rijdt de auto?). Dat maakt het een bijwoord. Let op: in 'de snelle auto' is het wél een bijvoeglijk naamwoord (het zegt iets over 'auto')!",
    "distractorExplanations": {
      "1": "Een bijvoeglijk naamwoord zegt iets over een zelfstandig naamwoord. Hier zegt 'snel' iets over het werkwoord 'rijdt'.",
      "2": "'Rijdt' is het werkwoord, niet 'snel'.",
      "3": "'Snel' is geen ding of persoon, dus geen zelfstandig naamwoord."
    }
  },
  {
    "id": "SR-B8-VOORZETSEL-OP-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "woordsoorten",
    "subSkill": "voorzetsels",
    "familyId": "SR-VOORZETSEL-HERKENNEN",
    "conceptId": "identify_preposition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het voorzetsel in de zin: 'De kat zit op de mat.'",
    "options": ["op", "De", "zit", "mat"],
    "correctAnswer": 0,
    "explanation": "Een voorzetsel geeft een relatie aan (plaats, tijd, richting). 'Op' vertelt waar de kat zit. Andere voorzetsels: in, met, naar, bij, voor.",
    "distractorExplanations": {
      "1": "'De' is een lidwoord.",
      "2": "'Zit' is de persoonsvorm (werkwoord).",
      "3": "'Mat' is een zelfstandig naamwoord."
    }
  },
  {
    "id": "SR-B8-LV-KRANT-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "zinsontleding",
    "subSkill": "lijdend_voorwerp",
    "familyId": "SR-LIJDEND-VOORWERP-VINDEN",
    "conceptId": "find_direct_object",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Wat is het lijdend voorwerp in de zin: 'Mijn oma leest elke avond de krant.'",
    "options": ["de krant", "Mijn oma", "leest", "elke avond"],
    "correctAnswer": 0,
    "explanation": "Wat leest mijn oma? De krant. 'De krant' is het lijdend voorwerp.",
    "distractorExplanations": {
      "1": "'Mijn oma' is het onderwerp (wie leest?).",
      "2": "'Leest' is de persoonsvorm.",
      "3": "'Elke avond' is een bijwoordelijke bepaling van tijd (wanneer?)."
    }
  },
  {
    "id": "SR-B8-WOORDSOORT-IN-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "woordsoorten",
    "subSkill": "voorzetsels",
    "familyId": "SR-VOORZETSEL-HERKENNEN",
    "conceptId": "identify_preposition",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woordsoort is 'in' in de zin: 'De vis zwemt in het water.'",
    "options": ["Voorzetsel", "Bijwoord", "Lidwoord", "Voegwoord"],
    "correctAnswer": 0,
    "explanation": "'In' is een voorzetsel. Het geeft de plaats aan waar de vis zwemt. 'In' hoort bij 'het water' (voorzetselgroep).",
    "distractorExplanations": {
      "1": "Een bijwoord staat los, maar 'in' hoort bij 'het water' — het is een voorzetsel.",
      "2": "Een lidwoord is de/het/een. 'In' is geen lidwoord.",
      "3": "Een voegwoord verbindt zinnen (en, maar, want). 'In' verbindt geen zinnen."
    }
  },
  {
    "id": "SR-B8-MV-LEERLINGEN-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "zinsontleding",
    "subSkill": "meewerkend_voorwerp",
    "familyId": "SR-MEEWERKEND-VOORWERP-VINDEN",
    "conceptId": "find_indirect_object",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Wat is het meewerkend voorwerp in de zin: 'De leraar geeft de leerlingen huiswerk.'",
    "options": ["de leerlingen", "De leraar", "huiswerk", "geeft"],
    "correctAnswer": 0,
    "explanation": "Aan wie geeft de leraar huiswerk? Aan de leerlingen. Dat is het meewerkend voorwerp.",
    "distractorExplanations": {
      "1": "'De leraar' is het onderwerp (wie geeft?).",
      "2": "'Huiswerk' is het lijdend voorwerp (wat geeft hij?).",
      "3": "'Geeft' is de persoonsvorm."
    }
  },
  {
    "id": "SR-B8-VOEGWOORD-WANT-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "woordsoorten",
    "subSkill": "voegwoorden",
    "familyId": "SR-VOEGWOORD-HERKENNEN",
    "conceptId": "identify_conjunction",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is een voegwoord in de zin: 'Ik ga naar huis, want ik ben moe.'",
    "options": ["want", "naar", "Ik", "ben"],
    "correctAnswer": 0,
    "explanation": "'Want' is een voegwoord. Het verbindt twee zinnen en geeft een reden aan. Andere voegwoorden: en, maar, of, dus, omdat.",
    "distractorExplanations": {
      "1": "'Naar' is een voorzetsel (richting).",
      "2": "'Ik' is een persoonlijk voornaamwoord.",
      "3": "'Ben' is een werkwoord."
    }
  },
  {
    "id": "SR-B8-MV-VRIEND-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "zinsontleding",
    "subSkill": "meewerkend_voorwerp",
    "familyId": "SR-MEEWERKEND-VOORWERP-VINDEN",
    "conceptId": "find_indirect_object",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Ontleed de zin: 'De jongen gooit de bal naar zijn vriend.'\n\nWat is 'naar zijn vriend'?",
    "options": ["Meewerkend voorwerp", "Lijdend voorwerp", "Onderwerp", "Persoonsvorm"],
    "correctAnswer": 0,
    "explanation": "Naar wie gooit de jongen de bal? Naar zijn vriend. Dat is het meewerkend voorwerp.",
    "distractorExplanations": {
      "1": "'De bal' is het lijdend voorwerp (wat gooit hij?).",
      "2": "'De jongen' is het onderwerp (wie gooit?).",
      "3": "'Gooit' is de persoonsvorm."
    }
  },
  {
    "id": "SR-B8-VOEGWOORD-EN-V01",
    "module": "SpellingRegel",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "skill": "woordsoorten",
    "subSkill": "voegwoorden",
    "familyId": "SR-VOEGWOORD-HERKENNEN",
    "conceptId": "identify_conjunction",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woordsoort is 'en' in de zin: 'Jan en Piet spelen buiten.'",
    "options": ["Voegwoord", "Voorzetsel", "Bijwoord", "Lidwoord"],
    "correctAnswer": 0,
    "explanation": "'En' is een voegwoord. Het verbindt twee woorden of zinsdelen: Jan en Piet.",
    "distractorExplanations": {
      "1": "Een voorzetsel geeft een relatie aan (in, op, met). 'En' verbindt woorden.",
      "2": "Een bijwoord zegt iets over een werkwoord. 'En' verbindt woorden.",
      "3": "Een lidwoord is de/het/een. 'En' is geen lidwoord."
    }
  }
]